<template>
  <div class="body-container" style="height: 100%" @scroll="scrollEvent" id="container">
    <div class="upper-part" id="upper-part">
      <section class="banner-wrap" v-if="bannerList.length > 0">
        <swiper ref="swiper" :options="bannerOption">
          <swiper-slide class="banner" v-for="(i, index) in bannerList" :key="index">
            <img :src="i.resource_url" @click="goAdvertisementDetail(i.uuid)" />
          </swiper-slide>
        </swiper>
      </section>
      <section class="padding">
          <div class="tab-box" ref="tabBox" id="tab-box">
            <div class="tabs-content">
              <button
                id="company"
                class="tabs-item"
                :class="{ 'is-active': tab.code === tabActive }"
                v-for="(tab, index) in tabList"
                :key="index"
                @click="handleTab(tab)"
              >
                <span>{{ tab.name }}</span>
              </button>
            </div>
          </div>
      </section>
    </div>
    <section class="lower-box">
        <div class="list" id="cathay-pacific">
          <section>
              <div class="flex">
                <div class="title-left-box">
                  <div class="title-left-upper-box">
                    <img src="../../assets/images/fund/cathay.png" width="18" height="18" style="margin-right: 12px" />
                    <div class="title-wrap">
                      <div class="list-title">國泰投信</div>
                    </div>
                  </div>              
                  <span class="subtitle">台美股、債券基金首選品牌</span>
                </div>
              </div>
              <span class="readmore" @click="openExternalLink('fund_click_cathaysite_fundlist', '/w/fund/clickLink/cathayPacific')">
                查詢所有基金 >
              </span>          
          </section>
        </div>
        <div class="list">
          <div>
              <swiper ref="swiper" :options="productOption">
                <swiper-slide class="product" v-for="(i, index) in cathayPacificProductList" :key="index">
                  <div style="padding-bottom: 4px;">
                    <div class="product-img-box"><center><img :src="i.image" @click="openExternalLink(i.eventName, i.url)"/></center></div>
                    <div><span v-html=i.title style="font-size: 16px;"></span></div>
                    <div style="line-height: 12px;"><span class="subtitle" v-if="i.subtitle !== null">{{i.subtitle}}</span></div>
                  </div>                  
                </swiper-slide>
              </swiper>
            </div>
        </div>                    

      <div class="partner">
        <div class="update">持續更新中，敬請期待</div>
      </div>
    </section>
       

      <transition>
      <section v-show="dialogList.length !== 0">
        <div class="bottom-dialog" style="z-index: 1000" :class="dialogOpen ? 'up' : 'down'">
          <div class="title-wrap">
            <div class="title">{{ dialogList.title }}</div>
            <div class="icon-cancel" @click="closeBottomDialog"></div>
          </div>

          <div ref="bottomDialogContent" class="bottom-dialog-content" :class="dialogBorder ? 'dialog-navbar' : ''">
            <div @click="handleBillChildRoute(child)" v-for="child in dialogList.child" :key="child.path">
              <div class="block" v-show="child.show">
                <img v-show="child.icon" :src="child.icon" />
                <div>
                  <div class="text-gray2">{{ child.title1 }}</div>
                  <div :class="child.title2 === '' ? '' : 'text-nowrap'">{{ child.title2 }}</div>
                </div>
                <span class="arrow-right"></span>
              </div>
            </div>
          </div>
        </div>
        <div class="mask" style="z-index: 999; position: fixed;"></div>
      </section>
    </transition>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import { mapGetters, mapActions } from 'vuex';
import { getBanner, getFubonInsuranceUrl } from '../../api/api';
import { clearTimeout, setTimeout } from 'timers';

var scrollTimeout;

export default {
  name: 'fund-management',
  components: {
    Swiper,
    SwiperSlide
  },
  data() {
    return {
      list: [],
      tabActive: 'cathaysite',
      tabList: [
        {
          name : '國泰投信',
          code : 'cathaysite'
        }
      ],
      cathayPacificProductList: [
        {
          image: require('../../assets/images/fund/icon_fund_openaccount.png'),
          title: '立即申辦',
          subtitle: '國泰基金理財帳戶',
          eventName: 'fund_click_cathaysite_register',
          url: 'https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Fonline.cathaysite.com.tw%2Fopen-account%2F&verify=b9aa865c4f20530a7edbda0ce7bd94ff25ae35bc06b4378f8f49246c4e980b41'
        },
        {
          image: require('../../assets/images/fund/icon_fund_applypurchase.png'),
          title: '點我申購',
          subtitle: '登入申購基金',
          eventName: 'fund_click_cathaysite_subscriber',
          url: 'https://epkaw.easycard.com.tw/secureRedirect?link=https%3A%2F%2Fonline.cathaysite.com.tw%2Flogin&verify=277c60a63880a1723f04cc250de32c234cb09416c05ce7d16db19945c1bc0db7'
        }
      ],
      
      bannerList: [],
      bannerOption: {
        initialSlide: 0,
        spaceBetween: 10,
        slidesPerView: 'auto',
        centeredSlides: true,
        autoplay: { delay: 5000, disableOnInteraction: false },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      },
      productOption: {
        initialSlide: 0,
        spaceBetween: 16,
        slidesPerView: 'auto',
        centeredSlides: false,
        loop: false,
        freeMode: true,
      },
      dialogList: [],
      dialogOpen: false,
      dialogBorder: false,
    };
  },
  mounted() {
    this.sentApp({
      action: 'sendFirebaseEvent',
      payload: { event: 'mainpage_click_fund' },
    });
    getBanner().then((res) => {
      if (res !== undefined && (res.error === null || res.error === undefined) && res.data.hasOwnProperty('14')) {
        this.bannerList = res.data['14'];
      }
    });
    this.$refs.bottomDialogContent.addEventListener('scroll', this.dialogScroll);
  },
  destroyed() {
    this.$refs.bottomDialogContent.removeEventListener('scroll', this.dialogScroll);
  },
  methods: {
    ...mapActions(['sentApp']),    
    handleTab(item) {
      this.tabActive = item.code;    
      this.sentApp({
        action: 'sendFirebaseEvent',
        payload: { event: 'fund_click_' + item.code },
      });
      const container = document.getElementById("container");
      if (this.tabActive === 'cathay-pacific') {
        setTimeout(function() {
          var top = document.getElementById("cathay-pacific").offsetTop - document.getElementById("upper-part").offsetHeight;
          container.scrollTo({left: 0, top: top, behavior: 'smooth'});
        }, 100);
      } else {
        setTimeout(function() {
          var top = document.getElementById("pcalife").offsetTop - document.getElementById("upper-part").offsetHeight;
          container.scrollTo({left: 0, top: top, behavior: 'smooth'});
        }, 100);
      }
    },    
    goAdvertisementDetail(uuid) {
      this.sentApp({
        action: 'sendFirebaseEvent',
        payload: { event: 'click_ad_fund', payload: { advertisement_uuid: uuid} },
      });
      this.sentApp({
        action: 'showAdvertisementDetail',
        payload: { uuid: uuid },
      });
    },
    openExternalLink(eventName, url) {
      if (!url.startsWith('http')) {
        url = window.location.protocol + "//" + window.location.host + url;
      }
      this.sentApp({
        action: 'sendFirebaseEvent',
        payload: { event: eventName },
      });
      this.sentApp({
        action: 'openExternalBrowser',
        payload: { url: url },
      });
    },
    scrollEvent(event) {
      const pcalifeSectionTop = document.getElementById("pcalife").offsetTop - document.getElementById("upper-part").offsetHeight;
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        if (event.srcElement.scrollTop >= pcalifeSectionTop) {
            this.tabActive = this.tabList[1].code;
        } else {
            this.tabActive = this.tabList[0].code;
        }
      }, 100); 
    },
    handleBill() {
      if (this.sessionKey === null && this.sessionToken === null) {
        this.sentApp({
          action: 'sessionIsNull'
        })
      } else {
        this.dialogOpen = true;
        this.dialogList = this.billDialogList[0];
      }
    },
    handleBillChildRoute(child) {
      switch (child.code) {
        case 'scan':
          this.sentApp({
          action: 'openQRScanner',
          payload: {},
          });
          break;

          case 'query':
          this.closeBottomDialog();
          setTimeout(() => {
            this.dialogOpen = true;
            this.dialogList = this.billDialogList[1];
          }, 200);
          break;

          case 'fubon':
            this.getFubonInsuranceUrl();
          break;

          // case 'pcalife':
          //   break;
      }
    },
    closeBottomDialog() {
      this.dialogOpen = false;
      setTimeout(() => {
        this.dialogList = [];
      }, 200);
    },
    dialogScroll() {
      let scrollTop = this.$refs.bottomDialogContent.scrollTop;
      if (scrollTop > 0) {
        this.dialogBorder = true;
      } else {
        this.dialogBorder = false;
      }
    },
    getFubonInsuranceUrl() {
      getFubonInsuranceUrl().then((res) => {
        if (res.error === null || res.error === undefined) {
          this.sentApp({
            action: 'openExternalBrowser',
            payload: { url: res.start_url },
          });
          } else {
            alert(res.error.message);
          }
    });
    }
  },
  computed: {
    ...mapGetters(['sessionKey', 'sessionToken', 'supportFeatures']),
    billDialogList() {
      return [
        {
          condition: true,
          type: 'paymentMethod',
          title: '請選擇繳費方式',
          child: [
            {
              path: '/insuranceScanQR',
              icon: require('../../assets/images/insurance/scan.png'),
              title1: '',
              title2: '掃碼付款',
              show: true,
              eventName: '',
              code: 'scan'
            },
            {
              path: '/insuranceQuery',
              icon: require('../../assets/images/insurance/search.png'),
              title1: '',
              title2: '即查即繳',
              show: true,
              eventName: '',
              code: 'query'
            },
          ],
        },
        {
          condition: true,
          type: 'insuranceCompany',
          title: '請選擇欲繳費的保險公司',
          child: [
            {
              path: '/carFuelFee',
              icon: require('../../assets/images/insurance/fubon.png'),
              title1: '',
              title2: '富邦產險',
              show: true,
              eventName: '',
              code: 'fubon'
            },
            // {
            //   path: '/carFine',
            //   icon: require('../../assets/images/insurance/pcalife.png'),
            //   title1: '',
            //   title2: '保誠人壽',
            //   show: true,
            //   eventName: '',
            //   code: 'pcalife'
            // },
          ],
        }
     ]
    }
  }
};
</script>
<style lang="scss" scoped>
.body-container {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: auto;
    background-color: white;
}
.swiper-pagination {
  position: relative;
  left: 0;
  top: 0;
}

.speaker-box {
  align-content: center;
  text-align: center;
  background-color: white;
  margin-left: 20px;
  margin-right: 20px;
  padding: 8px 0 19px 0;
  box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.08);
}

.speaker-box:before {
  content: "";
  right: -120px;
  bottom: 40px;
  position: relative;
  width: 0;
  border-bottom: 10px solid white;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
}

.swiper-container {
  --swiper-theme-color: rgb(64, 64, 64);
}

.swiper-wrapper {
  align-items: center;;
}

.lower-box {
  background-color: rgb(249, 249, 249);
  height: 100vh;
}

.list .swiper-container {
  margin-left: 20px;
}

.product .subtitle {
  font-size: 12px;
  line-height: 8px;
  color: rgba(64, 64, 64, 0.75);
}

.product .title {
  font-size: 16px;
  line-height: 22px;
  font-family: PingFangTC-Medium;
  color: rgba(64, 64, 64, 1);
  white-space: pre-line;
}

.product div {

}

.list .swiper-container img {
  
}

.product-img-box {
  margin-top: 8px;
  margin-bottom: 8px;
  flex-direction: column;
  justify-content: center;
  height: 36px;
}

.swiper-slide {
  text-align: center;
  font-size: 18px;
  background: #fff;

  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
}

.swiper-slide img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8pt;
}

.upper-part {
  position: sticky;
  top: 0; /* Don't forget this, required for the stickiness */
  background-color: white;
  z-index: 997;
}

.product-img-box img {
  width: 44px;
  height: 44px;
}

.swiper-slide {
  width: 80%;
}

.product {
  margin: 4px;
  width: 120px;
  height: 100px;
  text-align: center;
  box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.08);
  margin-right: 20px
}

.banner-wrap {
  margin-top: 16px;
}

.readmore {
  font-size: 14px;
  color: rgba(64, 64, 64, 0.75);
  margin-right: 10px;
}

.flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 20px;
}

.title-left-upper-box {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.padding {
  padding: 36px 20px 0px 20px;
}

.title-left-box {
  display: flex;
  flex-direction: column;
}

.title-left-box .subtitle {
  margin-top: 8px;
  font-size: 12px;
  color: rgba(64, 64, 64, 0.75);
}

.title {
  font-size: 20px;
  color: rgb(64, 64, 64);
  font-family: PingFangTC-Semibold;
  text-align: center;

  span {
    color: rgb(0, 122, 200);
  }
}

.tab-box {

}

.tabs-content button {
  all: unset;
  cursor: pointer;
  margin-right: 20px;
  padding: 8px;
}

.tabs-content button.is-active {
  border-bottom-color: rgb(0, 122, 200);
  border-width: 2px;  
  border-bottom-style: solid;
}

.tabs-content button.is-active span {
  color: rgb(0, 122, 200);
}

.tabs-content button span {
  font-size: 16px;
}

.text {
  color: rgb(64, 64, 64);
  font-family: PingFangTC-Regular;
  font-size: 14px;
}

.list {
  margin: 0 0 0 0;

  section:first-child {
    padding: 16px 12px 12px 12px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .title-wrap {
    .list-subtitle {
      font-family: PingFangTC-Regular;
      color: rgba(64, 64, 64, 0.75);
      margin-top: 4px;
      font-size: 18px;
    }
  }

  .btn {
    width: revert;
    height: 32px;
    padding: 0px 16px 0px 16px;
    white-space: nowrap;
  }

  .arrow {
    transform: rotate(180deg);
  }
}

.list-detail {
  transition: all 0.1s ease-in-out;
  background-color: rgba(64, 64, 64, 0.05);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  //padding: 12px;
  height: 0;
  opacity: 0;
  text-align: justify;
  color: rgba(64, 64, 64, 0.75);
  font-size: 14px;
  font-family: PingFangTC-Regular;
}

.arrow {
    transform: revert;
}

.openDetail {
  height: auto;
  opacity: 1;

  .arrow {
    transform: none;
  }
}

ul {
  padding: 0px;
  margin-left: 12px;
}

ul li {
    /*
     * We want the bullets outside of the list,
     * so the text is aligned. Now the actual bullet
     * is outside of the list’s container
     */
    list-style-position: outside;
    list-style-type: "•";
    /*
     * Because the bullet is outside of the list’s
     * container, indent the list entirely
     */
    margin-right: 5px;
    padding: 0px;
    font-family: PingFangTC-Regular;
}

li span {
  position: relative;
  left: 5px;
}

.second {
  margin-top: 33px;
}

.partner {
  margin-top: 24px;
  height: 20%;

  .update {
    font-family: PingFangTC-Regular;
    color: rgb(199, 199, 199);
    justify-content: center;
    margin-top: 56px;
    text-align: center;
  }
}

.bill-button {
  position: fixed;
  bottom: 16px;
  font-family: PingFangTC-Medium;
  color: white;
  font-size: 14;
  background-color: rgb(40, 40 ,40);
  border-radius: 28px;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 998;
}

.bill-button-content {
  img {
    padding: 12px 0 12px 12px;
    width: 32px;
    height: 32px;
    vertical-align: middle;
  }

  span {
    padding: 14px 16px 14px 0;
    vertical-align: middle;
  }
}
.block {
  background-color: #fff;
  border-radius: 8px;
  margin: 0 20px 16px 20px;
  padding: 20px;
  font-size: 16px;
  font-family: PingFgangTC-Medium;
  display: flex;
  align-items: center;
  box-shadow: 0 4pt 8pt 0 rgba(0, 0, 0, 0.05);
}

.block img {
  width: 24px;
  height: 24px;
  margin-right: 8pt;
}

.block:active, .block-shadows:active {
  background: rgba(0, 0, 0, 0.05);
}

.text-gray2 {
  color: rgba(64, 64, 64, 1);
  min-width: 90px;
}

.arrow-right {
  margin-left: auto;
  width: 24px;
  height: 24px;
}

.up {
  animation: slideUp 0.3s ease-in-out both;
}

.down {
  animation: slideDown 0.3s ease-in-out both;
}

@keyframes slideUp {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0);
  }
}

@keyframes slideDown {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(100%);
  }
}

</style>
